<template>
<div class="step6">
  <p class="text1">店頭受取予約が完了しました</p>
  <p class="text2">ご予約ありがとうございます。<br>店頭受取のご予約が完了いたしました。</p>


  <div class="present">
    <h2 class="present-tit">早期ご予約特典</h2>
    <div class="present-content">
      <p class="present-catch">11月30日(土)までのご予約で、先着500名様にクリスマスプレゼント!</p>
      <p class="present-text">
        ● 11/30(土)までに、店頭にてお支払いいただいた方から先着とさせていただきます。<br>
        ● いろいろとご用意しております。店頭にてお選びいただき、お支払時にお渡しいたします。
      </p>
    </div>
  </div>

  <p class="text-center">予約日にご連絡、ご来店のない場合にはキャンセルとさせていただきます。</p>
  <p class="text-center">
    <small>
      ※ご予約内容のご変更はお電話のみの対応となります。ご了承ください。
    </small>
  </p>
<!--  <a href="http://addapter.xsrv.jp/test/g-spoon/" class="btn a">トップページへ戻る<i class="fas fa-chevron-right"></i></a>-->
  <router-link to="/" class="btn a">トップページへ戻る<i class="fas fa-chevron-right"></i></router-link>
</div>
</template>

<script>
export default {
  name: 'step6',
  props: [
    'buttonText',
    'step',
    'shops',
    'radioResult',
    'weeks',
    'calData',
    'reservation'
  ],
  mounted () {
    let modalCartBtn = document.getElementById('pageHeaderCartBtn')
    modalCartBtn.style.display = 'none'
  },
  methods: {
    prev: function(number) {
      this.$emit('prev',number)
    }
  }
}

</script>

<style scoped lang="scss">

  .present {
    border-radius: 3px;
    overflow: hidden;
    margin: 30px auto;
    &-tit {
      background-color: #eb8444;
      color: #fff;
      padding: 15px;
      font-size: 20px;
      text-align: center;
      margin-bottom: 0;
    }
    &-content {
      border: #eb8444 1px solid;
      padding: 15px;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    &-catch {
      color: #e21616;
      font-size: 20px;
      text-align: center;
    }
    &-text {
      font-size: 14px;
      line-height: 1.8em;
      padding-right: 120px;
      background: url(../assets/img/img_present-2021@2x.png) right top / 60px auto no-repeat;
    }
  }
.step6 {
}
.btn {
  text-align: center;
  display:block;
  margin: 30px auto 0;
  padding:15px 0;
  background-color: #831f17;
  color:#fff;
  width:80%;
  position: relative;
  &:hover {
    opacity:0.7;
    cursor: pointer;
  }
  i {
    margin-left: 15px;
  }
}
.text1 {
  font-size: 18px;
  font-weight: 530;
  line-height: 1.28;
  text-align: center;
  color: #333333;
}
.text2 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.64;
  text-align: center;
  color: #333333;
}

</style>
